import { readPersonalizationSettings } from '../user/storage/personalization';

import { Product } from 'src/types';

type Filter = (products: Product[]) => Product[];

// Get categories that the user wants to removed from localStorage.
const getRemovedCategories = () =>
  readPersonalizationSettings().notInterestedIn.categories.map(
    (x: { id: number | string }) => x.id
  );

// Filter products and remove products from categories that the user is not
// interested in.
export const filterCategories: Filter = products => {
  const removedCategories = getRemovedCategories();
  return products
    .filter(p => p?.category)
    .filter(
      p =>
        p?.category &&
        removedCategories.findIndex(
          (id: string | number) => p.category && id === p.category.id
        ) < 0
    ) as Product[];
};
